export const DEFAULT_IFRAME_TICKER =
  process.env.REACT_APP_DEFAULT_TICKER || '6301';

export const DEFAULT_IFRAME_MKT =
  process.env.REACT_APP_DEFAULT_MKT || 'JP';

export const IFRAME_CONTEXT_STORAGE_KEY =
  process.env.REACT_APP_IFRAME_CONTEXT_STORAGE_KEY || 'esmart.iframe.context';

export const TAB_IDS = ['1', '2', '3', '4', '5', '6'] as const;

export type TabId = (typeof TAB_IDS)[number];
